<template>
  <!--地址编辑-->
  <div id="addressedit">
    <h2 class="title">
      <a @click="back()" class="prev"></a>
      编辑地址
      <a class="save" @click="postAddress">保存</a>
    </h2>
    <ul>
      <li>
        <label>姓名</label>
        <input type="text" v-model="name">
      </li>
      <li>
        <label>电话</label>
        <input type="text" v-model="phone">
      </li>
      <!--
      <li>
        <label>地址</label>
        <input type="text">
      </li>
      -->
      <li>
        <label>省</label>
        <input type="text" v-model="province">
      </li>
      <li>
        <label>市</label>
        <input type="text" v-model="city">
      </li>
      <li>
        <label>区</label>
        <input type="text" v-model="county">
      </li>
      <li>
        <label>详细地址</label>
        <input type="text" v-model="address">
      </li>
    </ul>
    <!--默认地址-->
    <div class="default">
      <h6>设为默认地址</h6>
      <span :class="isDefault ? 'selected' : ''" @click="setDefault()"><i></i></span>
    </div>
    <a class="fixed-bar" @click="postAddress()">保存并使用</a>
    <div class="bg"></div>
  </div>
</template>

<script>
export default {
  name: 'AddressEdit',
  data () {
    return {
      topData: {},
      province: '',
      city: '',
      county: '',
      address: '',
      name: '',
      phone: '',
      address_id: this.$route.query.address_id ? this.$route.query.address_id : 0,
      isDefault: 0
    }
  },
  mounted () {
    this.editAdd()
  },
  methods: {
    postAddress () {
      let data = {
        province: this.province,
        city: this.city,
        county: this.county,
        address: this.address,
        name: this.name,
        phone: this.phone,
        address_id: this.address_id,
        default: this.isDefault
      }
      this.$axios({
        method: 'POST',
        url: '/api/app/v1/post_update_order_receipt_address',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.back()
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    getAddress () {
      let data = {
        address_id: this.address_id
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_the_order_receipt_address',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.province = res.data.data.province
            this.city = res.data.data.city
            this.county = res.data.data.county
            this.address = res.data.data.address
            this.name = res.data.data.name
            this.phone = res.data.data.phone
            this.isDefault = res.data.data.default
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    back () {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    },
    setDefault () {
      if (this.isDefault === 1) {
        this.isDefault = 0
      } else {
        this.isDefault = 1
      }
      // this.isDefault = !this.isDefault
    },
    editAdd () {
      if (this.$route.query.address_id) {
        this.getAddress()
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  #addressedit
    .title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: #fff
      padding: .14rem .16rem
      font-size: .32rem
      color: #050505
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: #fff
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
      a.save
        position: absolute
        top: .14rem
        right: .4rem
        font-size: .28rem
        color: #9DA4B3
        font-weight: 400
    ul
      /*height: 5rem*/
      padding: .3rem .82rem
      background-color: #fff
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      li
        display: flex
        justify-content: left
        align-items: center
        width: 5.86rem
        height: 1rem
        border-bottom: .02rem solid #CFD1D4
        label
          margin-right: .3rem
        &:first-child
          background: url(../../assets/icon/addressedit_icon_person.png) no-repeat right center
          -webkit-background-size: .38rem .44rem
          background-size: .38rem .44rem
        &:last-child
          border: none
    .default
      display: flex
      justify-content: space-between
      align-items: center
      width: 7.5rem
      height: .8rem
      background-color: #fff
      padding: 0 .48rem
      margin-top: .32rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      span
        display: block
        width: .96rem
        height: .52rem
        background-color: #E1E1E1
        font-size: .28rem
        color: #050505
        -webkit-border-radius: .4rem
        -moz-border-radius: .4rem
        border-radius: .4rem
        i
          display: block
          width: .48rem
          height: .48rem
          background-color: #fff
          margin: .02rem 0 0 .02rem
          -webkit-border-radius: 50%
          -moz-border-radius: 50%
          border-radius: 50%
        &.selected
          background-color: #FF7052
          i
            margin: .02rem 0 0 .46rem
    a.fixed-bar
      position: relative
      display: block
      width: 6.7rem
      height: .8rem
      line-height: .8rem
      margin: 1rem auto
      background-color: #FF7052
      font-size: .28rem
      color: #fff
      text-align: center
      -webkit-border-radius: .4rem
      -moz-border-radius: .4rem
      border-radius: .4rem
    .bg
      position: fixed
      top: 0
      left: 0
      z-index: -1
      width: 100%
      height: 100%
      background-color: #F7F7F7
</style>



// WEBPACK FOOTER //
// src/components/personal/AddressEdit.vue